import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatMenuPanel } from "@angular/material/menu";
import { Function } from "../../model-services/function.service";
import { MODEL_COLOURS } from "../../model-services/model-item-enums";

@Component({
    selector: 'app-toolbar-button',
    templateUrl: './toolbar-button.html',
    standalone: false
})
export class ToolbarButtonComponent {
    @Input() function:Function

    @Input() dropdown:boolean
    @Input() name:string
    @Input() icon:string
    @Input() ariaLabel:string
    @Input() disabled:boolean
    @Input() triggerFor:MatMenuPanel<any>
    @Input() highlight:boolean

    @Output() buttonClickEvent = new EventEmitter<Function>();

    constructor(){}

    getIcon() {
        return this.icon?this.icon:this.function && this.function.icon
    }
    
    buttonName() {
        return this.function?this.function.name:this.name
    }
    
    buttonDescription() {
        return this.function?this.function.description:this.ariaLabel
    } 
    
    buttonClick() {
        this.buttonClickEvent.emit(this.function)
    }  

    isDisabled() {
        return this.function?this.function.disabled||this.disabled:this.disabled
    }

    isHighlight() {
        return this.highlight?`background: ${MODEL_COLOURS.NODE_SELECT_COLOR}`:""
    }
}
        